
import { SkeletonItem, Skeleton } from "element-ui";
export default {
  components: {
    SkeletonItem,
    Skeleton,
  },
};
